import React, { useState } from 'react'
import { bankQuestionService } from '../../services/bankQuestionService_moi'

const DatabaseTest: React.FC = () => {
  const [logs, setLogs] = useState<string[]>([])
  const [testing, setTesting] = useState(false)

  const addLog = (message: string) => {
    setLogs(prev => [...prev, `[${new Date().toLocaleTimeString()}] ${message}`])
    console.log(message)
  }

  const clearLogs = () => {
    setLogs([])
  }

  const testDatabaseLoad = async () => {
    setTesting(true)
    clearLogs()
    
    addLog('🔄 Starting database load test...')
    
    try {
      // Test parameters
      const lop = '11'
      const chuong = '1'
      const bai = '1'
      
      addLog(`🎯 Testing with parameters: L${lop}_C${chuong}_B${bai}`)
      
      // Test 1: Count questions
      addLog('📊 Testing question count...')
      const counts = await bankQuestionService.getQuestionCounts(lop, chuong, bai)
      addLog(`📊 Question counts: TN=${counts.TN}, DS=${counts.DS}, TL=${counts.TL}`)
      
      // Test 2: Load actual questions
      if (counts.TN > 0) {
        addLog('📖 Testing question loading (TN)...')
        const questions = await bankQuestionService.getRandomQuestions(lop, chuong, bai, {
          thoiGianLamBai: 30,
          diemDat: 70,

        })
        addLog(`📖 Loaded ${questions.cauHoi.length} questions`)
        
        if (questions.cauHoi.length > 0) {
          addLog(`🔍 Sample question: ${questions.cauHoi[0].cau_hoi.substring(0, 100)}...`)
        }
      }
      
      addLog('✅ Database test completed')
      
    } catch (error) {
      addLog(`❌ Database test failed: ${error.message}`)
      console.error('Full error:', error)
    } finally {
      setTesting(false)
    }
  }

  const testDirectFetch = async () => {
    setTesting(true)
    clearLogs()
    
    addLog('🔄 Testing direct database fetch...')
    
    const dbPath = '/bank/L11/C1/B01/TN/questions.db'
    
    try {
      addLog(`📡 Fetching: ${dbPath}`)
      const response = await fetch(dbPath)
      
      addLog(`📡 Response: ${response.status} ${response.statusText}`)
      addLog(`📦 Content-Type: ${response.headers.get('content-type')}`)
      addLog(`📦 Content-Length: ${response.headers.get('content-length')} bytes`)
      
      if (response.ok) {
        const arrayBuffer = await response.arrayBuffer()
        addLog(`📦 ArrayBuffer size: ${arrayBuffer.byteLength} bytes`)
        
        // Check SQLite header
        const uint8Array = new Uint8Array(arrayBuffer)
        const header = new TextDecoder().decode(uint8Array.slice(0, 16))
        addLog(`🔍 File header: "${header}"`)
        
        if (header.startsWith('SQLite format 3')) {
          addLog('✅ Valid SQLite file detected')
        } else {
          addLog('❌ Invalid SQLite file format')
        }
      } else {
        addLog(`❌ Failed to fetch database file`)
      }
      
    } catch (error) {
      addLog(`❌ Direct fetch failed: ${error.message}`)
    } finally {
      setTesting(false)
    }
  }

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Database Load Test</h2>
      
      <div className="flex gap-4 mb-4">
        <button
          onClick={testDatabaseLoad}
          disabled={testing}
          className="btn-primary px-4 py-2 rounded disabled:opacity-50"
        >
          {testing ? 'Testing...' : 'Test Service Load'}
        </button>
        
        <button
          onClick={testDirectFetch}
          disabled={testing}
          className="btn-secondary px-4 py-2 rounded disabled:opacity-50"
        >
          {testing ? 'Testing...' : 'Test Direct Fetch'}
        </button>
        
        <button
          onClick={clearLogs}
          className="btn-soft px-4 py-2 rounded"
        >
          Clear Logs
        </button>
      </div>
      
      <div className="bg-gray-100 p-4 rounded max-h-96 overflow-y-auto">
        {logs.length === 0 ? (
          <p className="text-gray-500">No logs yet. Click a test button to start.</p>
        ) : (
          logs.map((log, index) => (
            <div key={index} className="font-mono text-sm mb-1">
              {log}
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default DatabaseTest